import React from "react";

/**
 * Per design-system/landing.md §4. Used by any section that needs a grid of
 * short, icon-led statements (Problem, How it works) — not just spotlights.
 */
export default function FeatureCard({ icon: Icon, title, children }) {
  return (
    <div className="group rounded-xl border border-rf-border bg-rf-bg-secondary p-6 transition-all duration-200 hover:-translate-y-0.5 hover:border-rf-accent/30">
      {Icon && (
        <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-rf-accent/10">
          <Icon className="h-6 w-6 text-rf-accent" aria-hidden="true" />
        </div>
      )}
      {title && (
        <h3 className="mb-2 text-lg font-semibold text-rf-text-primary">{title}</h3>
      )}
      <p className="text-sm leading-relaxed text-rf-text-secondary">{children}</p>
    </div>
  );
}
